module.exports = __webpack_public_path__ + "img/IMG_20191125_200003.e15de8c0.jpg";